import { render, staticRenderFns } from "./MagentoEditor.vue?vue&type=template&id=709db2a8&scoped=true&"
import script from "./MagentoEditor.vue?vue&type=script&lang=js&"
export * from "./MagentoEditor.vue?vue&type=script&lang=js&"
import style0 from "./MagentoEditor.vue?vue&type=style&index=0&id=709db2a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709db2a8",
  null
  
)

export default component.exports